import React from 'react'
import './Commission.css'

const Commission = () => {
  return (
    <>
        <section className="commission_section">
            <div className="container">
                <div className='row'>
                    <div className='col-md-8'>
                        <div className="commission_text_div">
                             <h2 className='commission_heading'>💰 Commissions</h2>
                            <p className='commission_para'>Accelerate your earnings with <b>high-paying commissions for each enrolled student, faster payouts, and 100% transparency at every step.</b></p>
                        </div>

                        <div className='comlistt'>
                            <div className='comflex'>
                                <div className='icondiv'>
                                    <img className='checkicon' src={process.env.PUBLIC_URL + '/assets/images/advantage/commission/check.png'} />
                                </div>
                                <div className='testdiv'>
                                    <h5 className='titleh6'>⚡ Fast & Transparent Payouts</h5>
                                    <p className='comlistpara'>Get paid as soon as we get paid. The moment funds are received from universities and EdTech providers, your share is instantly released — no delays, no hidden deductions.</p>
                                </div>
                            </div>

                            <div className='comflex'>
                                <div className='icondiv'>
                                    <img className='checkicon' src={process.env.PUBLIC_URL + '/assets/images/advantage/commission/check.png'} />
                                </div>
                                <div className='testdiv'>
                                    <h5 className='titleh6'>📈 High-Value Promotions & Bonuses</h5>
                                    <p className='comlistpara'>Maximise your income through exclusive partner rewards — including seasonal bonuses, premium commission slabs on enrolled students, payout multipliers, and application fee waiver campaigns designed to drive more enrollments.</p>
                                </div>
                            </div>

                            <div className='comflex'>
                                <div className='icondiv'>
                                    <img className='checkicon' src={process.env.PUBLIC_URL + '/assets/images/advantage/commission/check.png'} />
                                </div>
                                <div className='testdiv'>
                                    <h5 className='titleh6'>🧾 Dedicated Commission Support</h5>
                                    <p className='comlistpara'>Have a question about your payouts? Our experienced accounts support team ensures quick and accurate resolutions, so you always stay informed and confident about your earnings.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className="commission_div">
                            <img className='commissionimg' src={process.env.PUBLIC_URL + '/assets/images/advantage/commission/commission.png'} />
                        </div>
                    </div>
                </div>


            </div>
        </section>   

    </>
  )
}   

export default Commission